module.exports = __webpack_public_path__ + "media/images/Tom-volunteering-in-shop-5db0be2a1f1889a514913c2df55e87ca.jpg";